import React from 'react';
import './About.css';

const values = [
  {
    title: 'People first',
    description: 'We listen carefully, communicate clearly, and build lasting partnerships.',
  },
  {
    title: 'Quality always',
    description: 'We combine thoughtful design, dependable engineering, and thorough testing.',
  },
  {
    title: 'Practical progress',
    description: 'We focus on useful solutions that create measurable value for your business.',
  },
];

const About = () => {
  return (
    <main className="about-page">
      <section className="about-intro">
        <span className="about-eyebrow">About Us</span>
        <h1>Technology with a human touch.</h1>
        <p>
          SnowTechLabs helps businesses grow with reliable digital products, thoughtful strategy, and technology that works.
        </p>
      </section>

      <section className="about-story">
        <div>
          <span className="about-kicker">Who we are</span>
          <h2>We turn ideas into dependable digital experiences.</h2>
        </div>
        <p>
          From web and mobile development to quality engineering and digital marketing, our team brings the right mix of creativity and technical expertise to every project. We work closely with our clients to understand their goals and deliver solutions built for the long term.
        </p>
      </section>

      <section className="about-values" aria-labelledby="about-values-title">
        <div className="about-section-heading">
          <span className="about-kicker">What guides us</span>
          <h2 id="about-values-title">Our values</h2>
        </div>
        <div className="about-value-list">
          {values.map((value) => (
            <article className="about-value" key={value.title}>
              <span className="about-value-mark">❆</span>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="about-contact">
        <h2>Let&apos;s work together.</h2>
        <p>Have an idea or a challenge to solve? Our team would love to hear about it.</p>
        <a href="/#contact">Talk to our team <span aria-hidden="true">-&gt;</span></a>
      </section>
    </main>
  );
};

export default About;
